import iziToast from "izitoast";
import iziModal from "izimodal";
import {isUndefined} from "webpack-merge/dist/utils";

require('../../../../node_modules/izimodal/css/iziModal.min.css');
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/menu.css');
require('jquery-ui/themes/base/autocomplete.css');
require('jquery-ui/themes/base/theme.css');
var autocomplete = require('jquery-ui/ui/widgets/autocomplete');
require('./deliverynote');
const bulk_page = require('./bulk_page');
const contract_page = require('./contract_page');

$(document).ready(function (){

	var contractCodeSet = typeof contractCode != "undefined";
	var subcontractCodeSet = typeof subcontractCode != "undefined";

	if($('body').hasClass('layout-default')) {
		contract_page.init();
	} else if($('body').hasClass('layout-bulk')) {
		bulk_page.init();
	}

	$("ul.error li").each(function (){
		iziToast.error({
			title: '',
			message: $(this).text(),
			position: 'center', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
		});
	});

	$("#messenger li").each(function (){
		var options = {
			title: '',
			message: $(this).text(),
			position: 'center', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
		};
		if($(this).hasClass('flash-message-error')) {
			iziToast.error(options);
		}
		if($(this).hasClass('flash-message-success')) {
			iziToast.success(options);
		}
		if($(this).hasClass('flash-message-popup') || $(this).hasClass('flash-message-msg')) {
			iziToast.info(options);
		}
	});

	$("#downloads a.pdf__attachment").each(function(){
		attachPdfViewer($(this));
	});

	$(document).on('closed', '#modal-iframe', function (e) {
		$('#modal-iframe').iziModal('destroy');
	});
});

function attachPdfViewer($element) {
	$element.on('click', function(e) {
		e.preventDefault();
		console.log('click');
		var url = $element.attr('href');
		url = url.replace('\\', '/');

		$("#modal-iframe").iziModal({
			widht: '90vw',
			iframe: true,
			iframeHeight: '90vh',
			iframeURL: ROOT + "ciadmin/front/js/pdfjs/web/viewer.html?file=" + url + "#zoom=page-fit"
		}).iziModal('open');
	});
}
